import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';
import { CategoryDTO, TopicDTO } from '../_models/category';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  constructor(private http: HttpClient) {}

  createCategory(payload: CategoryDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createCategory}`,
      payload
    );
  }

  createSubCategory(payload: CategoryDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createSubCategory}`,
      payload
    );
  }

  createTopic(payload: TopicDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createTopic}`,
      payload
    );
  }

  getAllCategories() {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllCategories}`
    );
  }

  getAllSubcategories(categoryId) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllSubCategories}/${categoryId}/subcategories`
    );
  }

  getllTopics(subCategoryId) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllTopics}/${subCategoryId}/all`
    );
  }

  deleteCategory(categoryId) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteCategory}/${categoryId}`
    );
  }

  deleteTopic(topicId) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteTopic}/${topicId}`
    );
  }
}
